"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { Link } from "@/components/LocaleLink";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/lib/hooks/useTranslation";
import { safeGetItem, safeSetItem } from "@/lib/safeStorage";
import { Cookie, X } from "lucide-react";
const COOKIE_CONSENT_KEY = "velyq-cookie-consent";
export function CookieBanner() {
  const $ = _c(30);
  const {
    locale
  } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const consent = safeGetItem(COOKIE_CONSENT_KEY);
      if (!consent) {
        const timer = setTimeout(() => setIsVisible(true), 1000);
        return () => clearTimeout(timer);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      safeSetItem(COOKIE_CONSENT_KEY, "accepted");
      setIsVisible(false);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleAccept = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      safeSetItem(COOKIE_CONSENT_KEY, "refused");
      setIsVisible(false);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleRefuse = t3;
  if (!isVisible) {
    return null;
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fr: {
        title: "Cookies & Analytics",
        description: "Velyq utilise le stockage local pour l'authentification et vos pr\xE9f\xE9rences. En acceptant, vous autorisez \xE9galement Google Analytics et PostHog pour am\xE9liorer votre exp\xE9rience (donn\xE9es anonymis\xE9es).",
        learnMore: "En savoir plus",
        accept: "Accepter",
        refuse: "Refuser"
      },
      en: {
        title: "Cookies & Analytics",
        description: "Velyq uses local storage for authentication and your preferences. By accepting, you also allow Google Analytics and PostHog to improve your experience (anonymized data).",
        learnMore: "Learn more",
        accept: "Accept",
        refuse: "Refuse"
      }
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const content = t4;
  const t = content[locale];
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="hidden sm:flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10"><Cookie className="h-5 w-5 text-primary" /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t.title) {
    t6 = <h3 className="font-semibold">{t.title}</h3>;
    $[6] = t.title;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <X className="h-4 w-4" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t.refuse) {
    t8 = <button onClick={handleRefuse} className="sm:hidden text-muted-foreground hover:text-foreground" aria-label={t.refuse}>{t7}</button>;
    $[9] = t.refuse;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t8) {
    t9 = <div className="flex items-center justify-between gap-2">{t6}{t8}</div>;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t.description) {
    t10 = <p className="text-sm text-muted-foreground">{t.description}</p>;
    $[14] = t.description;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t.accept) {
    t11 = <Button onClick={handleAccept} size="sm">{t.accept}</Button>;
    $[16] = t.accept;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t.refuse) {
    t12 = <Button onClick={handleRefuse} size="sm" variant="ghost">{t.refuse}</Button>;
    $[18] = t.refuse;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t.learnMore) {
    t13 = <Link href="/privacy" className="text-sm text-muted-foreground hover:text-primary underline-offset-4 hover:underline">{t.learnMore}</Link>;
    $[20] = t.learnMore;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t11 || $[23] !== t12 || $[24] !== t13) {
    t14 = <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">{t11}{t12}{t13}</div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t10 || $[27] !== t14 || $[28] !== t9) {
    t15 = <div data-nosnippet={true} className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom-5 duration-300"><div className="mx-auto max-w-4xl"><div className="rounded-lg border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 shadow-lg p-4 md:p-6"><div className="flex items-start gap-4">{t5}<div className="flex-1 space-y-3">{t9}{t10}{t14}</div></div></div></div></div>;
    $[26] = t10;
    $[27] = t14;
    $[28] = t9;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
}